// Samtykke til informasjonskapsler, lagret i nettleseren av CookieBanner.
//
// Én kilde for alt som sporer: GA4 lastes først etter samtykke til analyse, Meta
// Pixel først etter samtykke til markedsføring (TrackingScripts), og Meta-hendelser
// server-side (CAPI) sendes bare med samtykke til markedsføring. Fram til 3.10.2026
// lastet både GA4 og Meta Pixel på første sidevisning, før noe valg var gjort, og
// Meta fyrte også for dem som trykket «Kun nødvendige».
export const SAMTYKKE_NOKKEL = 'cg_cookie_consent';
export const SAMTYKKE_ENDRET = 'cg-samtykke-endret';
export const APNE_SAMTYKKE = 'cg-apne-samtykke';

// Sendes til Stripe som client_reference_id fra CheckoutLink når kjøperen har sagt
// ja til markedsføring. Webhooken sender kjøpet til Meta bare når den finnes.
export const STRIPE_SAMTYKKE_REF = 'samtykke-markedsforing';

export type Samtykke = { analytics: boolean; marketing: boolean };

export function hentSamtykke(): Samtykke | null {
  if (typeof window === 'undefined') return null;
  try {
    const lagret = localStorage.getItem(SAMTYKKE_NOKKEL);
    if (!lagret) return null;
    const s = JSON.parse(lagret);
    return { analytics: s.analytics === true, marketing: s.marketing === true };
  } catch {
    // localStorage kan kaste i privat modus; da finnes ikke noe samtykke.
    return null;
  }
}
